import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Ranking from './components/Ranking';
import Media from './components/Media';
import AppEntry from './components/AppEntry';
import Carousel from './components/Carousel';
import Topics from './components/Topics';
import Comments from './components/Comments';
import About from './components/About';
import Updates from './components/Updates';
import Cards from './components/Cards';
import Faq from './components/Faq';
import Index from './components/Index';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Ranking />
        <Media />
        <AppEntry />
        <Carousel />
        <Topics />
        <Comments />
        <About />
        <Updates />
        <Cards />
        <Faq />
        <Index />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}